<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 0,
  },
  displayValue: {
    type: [String, Number],
    default: '',
  },
});

const widthPct = computed(() => {
  if (!props.max || props.max <= 0) return 0;
  return Math.min(100, Math.round((props.value / props.max) * 100));
});
</script>

<template>
  <div class="flex items-center gap-3 w-full">
    <span class="w-28 shrink-0 text-sm text-n-slate-11 truncate">
      {{ label }}
    </span>
    <div class="flex-1 h-2.5 rounded-full bg-n-alpha-2 overflow-hidden">
      <div
        class="h-full rounded-full bg-n-brand transition-all"
        :style="{ width: `${widthPct}%` }"
      />
    </div>
    <span class="w-16 shrink-0 text-sm text-end text-n-slate-12">
      {{ displayValue === '' ? value : displayValue }}
    </span>
  </div>
</template>
